<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform -translate-y-4 opacity-0"
      enter-to-class="transform translate-y-0 opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="transform translate-y-0 opacity-100"
      leave-to-class="transform -translate-y-4 opacity-0"
    >
      <div
        v-if="visible"
        class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[99999] px-6 py-3 rounded-lg shadow-lg text-white text-base font-medium min-w-[200px] text-center"
        :class="typeClass"
      >
        {{ message }}
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { ref, computed } from 'vue'

const useToast = () => {
  const visible = ref(false)
  const message = ref('')
  const type = ref('success')
  let timer = null

  const typeClass = computed(() => ({
    'bg-green-500': type.value === 'success',
    'bg-red-500': type.value === 'error',
    'bg-yellow-500': type.value === 'warning',
    'bg-blue-500': type.value === 'info'
  }))

  const show = (msg, options = {}) => {
    if (timer) clearTimeout(timer)
    message.value = msg
    type.value = options.type || 'success'
    visible.value = true
    timer = setTimeout(() => {
      visible.value = false
    }, options.duration || 3000)
  }

  return {
    visible,
    message,
    typeClass,
    show
  }
}

// Define and export the component
const ComponentToast = {
  name: 'ComponentToast',
  setup() {
    return useToast()
  }
}

// Export the component as default
export default ComponentToast
</script>